import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { rootStore } from 'models/root';
import { MobxProvider } from 'context/store';
import { ReferenceProvider } from 'context/reference';
import { DrawerProvider } from 'context/drawer';
import { FiltersProvider } from 'context/filters';
import { AbilityContext, ability } from 'services/casl';
import NetworkDetector from 'components/shared/NetworkDetector';
import SnackbarAction from 'components/shared/SnackbarAction';
import SnackbarCustom from 'components/shared/SnackbarCustom';
import { useReferences, useDrawerContextValues, useFiltersContextValues } from 'hooks';
import Routes from 'routes';
import theme from 'theme';

import 'assets/scss/index.scss';

const App = () => {
  const references = useReferences();
  const drawerValues = useDrawerContextValues();
  const filtersValues = useFiltersContextValues();

  return (
    <StrictMode>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AbilityContext.Provider value={ability}>
          <MobxProvider value={rootStore}>
            <ThemeProvider theme={theme}>
              <ReferenceProvider value={references}>
                <DrawerProvider value={drawerValues}>
                  <FiltersProvider value={filtersValues}>
                    <SnackbarProvider
                      maxSnack={3}
                      autoHideDuration={3000}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      action={key => <SnackbarAction keyProp={key} />}
                      Components={{
                        custom: SnackbarCustom,
                      }}
                    >
                      <NetworkDetector />
                      <BrowserRouter>
                        <Routes />
                      </BrowserRouter>
                    </SnackbarProvider>
                  </FiltersProvider>
                </DrawerProvider>
              </ReferenceProvider>
            </ThemeProvider>
          </MobxProvider>
        </AbilityContext.Provider>
      </LocalizationProvider>
    </StrictMode>
  );
};

export default App;
